import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

type Props = {
  disabled: boolean;
  onEdit: () => void;
};

export default function EditBtn({ disabled, onEdit }: Props) {
  const { t } = useTranslation("users");

  return (
    <Tooltip title={t("common:edit")}>
      <span>
        <IconButton
          size="small"
          data-testid="roles__edit-role-btn"
          disabled={disabled}
          onClick={onEdit}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
